import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { BitacoraPrioridadENUM, ModulosMotivoENUM, newMotivosSchema } from '@/shared';
import { useCreateMotivo, useUpdateMotivo } from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { IDataMotivo } from '@/shared/interfaces/erp/inventario/motivo.interface';


const returnUrlMotivo = '/parametrizacion/motivos';

export interface SaveMotivoInterface {
  titlePage: string;
  editMotivo?: IDataMotivo;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  modulo: string;
  estado: boolean;
  prioridad:string;
};

const SaveMotivoPage: React.FC<SaveMotivoInterface> = ({ titlePage, editMotivo }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createMotivossMutation = useCreateMotivo({ navigate, returnUrl: returnUrlMotivo });
  const updateMotivossMutation = useUpdateMotivo({ navigate, returnUrl: returnUrlMotivo });
  const modulosOptions = Object.entries(ModulosMotivoENUM).map(
    ([key, value]) => ({ label: key, value })
  );
  const prioridadesOptions = Object.entries(BitacoraPrioridadENUM).map(
     ([Key, value]) =>({label: Key, value})
  );
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newMotivosSchema),
    defaultValues: { estado: false },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editMotivo?.id_motivo) {
      return updateMotivossMutation.mutate({
        id: editMotivo.id_motivo,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createMotivossMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editMotivo) {
      setShrink(true);
      reset({
        ...editMotivo
      } as any);
    }
  }, [editMotivo]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlMotivo);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Codigo"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomTextField
        label="nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomAutocomplete
        label="Modulo"
        name="modulo"
        control={form.control}
        defaultValue={form.getValues().modulo || ''}
        error={errors.modulo}
        helperText={errors.modulo?.message}
        options={modulosOptions}
        isLoadingData={false}
        valueKey="value"
        optionLabelForEdit={form.getValues().modulo}
      />
      <CustomAutocomplete
       label="prioridad"
       name="prioridad"
       control={form.control}
       defaultValue={form.getValues().prioridad || ''}
       error={errors.prioridad}
       helperText={errors.prioridad?.message}
       options={prioridadesOptions}
       isLoadingData={false}
       valueKey="value"
       optionLabelForEdit={form.getValues().prioridad}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado || false}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveMotivoPage;
